export function resolveValue(option, getter) {
  return getter.split('.').reduce((prev, curr) => {
    return prev[curr]
  }, option)
}
